// extracted by mini-css-extract-plugin
export default {"applyMargin":"CriteriaFilter_applyMargin_zVNWW","dropdownItem":"CriteriaFilter_dropdownItem_G46zw","spinAround":"CriteriaFilter_spinAround_o7X5O"};